import * as echarts from 'echarts';
import i18n from "../../../../i18n";

function rand(maxNum, minNum, decimalNum) {
    var max = 0,
        min = 0;
    minNum <= maxNum
        ? ((min = minNum), (max = maxNum))
        : ((min = maxNum), (max = minNum));
    switch (arguments.length) {
        case 1:
            return Math.floor(Math.random() * (max + 1));
        case 2:
            return Math.floor(Math.random() * (max - min + 1) + min);
        case 3:
            return (Math.random() * (max - min) + min).toFixed(decimalNum);
        default:
            return Math.random();
    }
}
var chartData = {
    chart1: {
        title: i18n.global.t('Daily inspiratory electricity consumption'),
        legendData: [i18n.global.t('Unit No. 1') + i18n.global.t('Suction power consumption'),
        i18n.global.t('Unit No. 2') + i18n.global.t('Suction power consumption'), i18n.global.t('Vacuum station integrated suction')],
        data: [
            {
                name: i18n.global.t('Unit No. 1') + i18n.global.t('Suction power consumption'),
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: [50, 71, 61, 81, 51, 41, 67, 77, 61, 81, 41, 51, 71, 81, 51, 64, 75, 72, 41, 51, 61, 51].map(item => {
                    return rand(item, 85)
                })
            },

            {
                name: i18n.global.t('Unit No. 2') + i18n.global.t('Suction power consumption'),
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: [0, 0, 0, 0, 0, 0, 0, 0, 60, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
                name: i18n.global.t('Vacuum station integrated suction'),
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                data: [80, 71, 81, 81, 81, 71, 81, 81, 81, 81, 71, 81, 81, 71, 81, 81, 71, 81, 81, 81, 81, 81].map(() => {
                    return rand(20, 85)
                })
            }]
    },
    chart2: {
        title: i18n.global.t('Daily Inhalation'),

        legendData: ['1' + i18n.global.t('Unit Aspiration'), '2' + i18n.global.t('Unit Aspiration'),
        '4' + i18n.global.t('Vacuum station suction'), '4' + i18n.global.t('Vacuum station integrated suction')],
        data: [{
            name: '1' + i18n.global.t('Unit Aspiration'),
            type: 'bar',
            barGap: 0,
            emphasis: {
                focus: 'series'
            },
            data: [75, 65, 77, 78, 65, 66, 70, 90, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81].map(() => {
                return rand(20, 100)
            })
        },
        {
            name: '2' + i18n.global.t('Unit Aspiration'),
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 71, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: '4' + i18n.global.t('Vacuum station suction'),
            type: 'line',
            emphasis: {
                focus: 'series'
            },
            data: [61, 63, 63, 63, 73, 65, 65, 65, 65, 67, 60, 65, 66, 70, 70, 70, 70, 70, 70, 70, 70, 70]
        },

            // {
            //     name: '4真空站综合吸气',
            //     type: 'line',
            //     emphasis: {
            //         focus: 'series'
            //     },
            //     data: [6200, 6100, 6250, 6200, 7300, 6400, 6200, 6100, 6300, 6500, 5900, 6200, 6400, 6700, 6800, 6600, 6900, 6800, 6800, 6800, 6800, 6800]
            // }
        ]
    },
    chart3: {
        title: i18n.global.t('Daily electricity consumption'),

        legendData: ['1' + i18n.global.t('Electricity consumption of the unit'), '2' + i18n.global.t('Electricity consumption of the unit'),
        i18n.global.t('Vacuum power consumption')],
        data: [{
            name: '1' + i18n.global.t('Electricity consumption of the unit'),
            type: 'bar',
            barGap: 0,
            emphasis: {
                focus: 'series'
            },
            data: [80, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81, 81].map(() => {
                return rand(50, 300)
            })
        },
        {
            name: '2' + i18n.global.t('Electricity consumption of the unit'),
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 71, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: i18n.global.t('Vacuum power consumption'),
            type: 'line',
            emphasis: {
                focus: 'series'
            },
            data: [63, 63, 63, 63, 73, 65, 65, 65, 65, 67, 60, 65, 66, 70, 70, 70, 70, 70, 70, 70, 70, 70].map(item => {
                return rand(item, 85)
            })
        },

        ]
    },
    chart4: {},
    chart5: {},
    chart6: {
        title: i18n.global.t('Daily inspiratory electricity consumption'),
        legendData: [i18n.global.t('Screw pump motor'), i18n.global.t("Roots pump motor"), i18n.global.t("Roots pump motor rated power"), i18n.global.t("Screw pump motor rated power")],
        data: [
            {
                name: i18n.global.t("Screw pump motor"),
                barGap: 0,
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: [1.8, 0.6, 0.61, 0.81, 1, 2, 2.5, 1, 1.4, 0.2, 0.5, 1.8].map(() => {
                    return rand(100, 117)
                }),
                markLine: {
                    data: [{
                        type: 'average',
                        name: i18n.global.t("Roots pump motor rated power"),
                        yAxis: 168,
                        label: {
                            fontSize: 20
                        },
                        lineStyle: { color: "#3949AB" }
                    }]
                }

            },

            {
                name: i18n.global.t("Roots pump motor"),
                type: 'bar',
                barGap: 0,
                emphasis: {
                    focus: 'series'
                },
                data: [0.5, 0.3, 0.2, 0.4, 0.6, 0.2, 1, 1.4, 0.8, 0.9, 0.2, 0.2].map(() => {
                    return rand(33, 37)
                }),
                markLine: {
                    data: [{
                        type: 'average',
                        name: i18n.global.t("Roots pump motor rated power"),
                        yAxis: 48,

                        label: {
                            fontSize: 20
                        },
                        lineStyle: { color: "#CF6FC6" }
                    }]
                }
            },
            {
                name: i18n.global.t("Roots pump motor rated power"),
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: '#CF6FC6'
                },
                symbol: "none",
                data: [],

            },
            {
                name: i18n.global.t("Screw pump motor rated power"),
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: '#3949AB'
                },
                symbol: "none",
                data: [],

            }

        ]
    },
    chart8: {
        title: i18n.global.t('Daily inspiratory electricity consumption'),
        legendData: [i18n.global.t("iV706 Intelligent Vacuum Unit"), "额定功率"],
        data: [
            {
                name: i18n.global.t("iV706 Intelligent Vacuum Unit"),
                barGap: 0,
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: [1.8, 0.6, 0.61, 0.81, 1, 2, 2.5, 1, 1.4, 0.2, 0.5, 1.8],

            },
            {
                name: '额定功率',
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: '#CF6FC6'
                },
                symbol: "none",
                data: [],
                markLine: {
                    data: [{
                        type: 'average',
                        name: '额定功率',
                        yAxis: 2.4,
                    }]
                }
            }
        ]
    },
}
const spectrumEcharts = (id) => {

    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        legend: {
            data: chartData[id].legendData,
            top: 20,
            textStyle: {
                //图例字体大小
                fontSize: 18,
            },
        },
        title: {
            text: chartData[id].title,
            textStyle: {
                fontSize: 18
            },
            top: 10,
            left: 10
        },
        // grid: {
        //     left: 100,
        //     right: 100
        // },
        toolbox: {
            show: false,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar', 'stack'] },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisTick: { show: false },
                data: ['2022-08-09', '2022-08-10', '2022-08-11', '2022-08-12', '2022-08-13', '2022-08-14', '2022-08-15', '2022-08-16', '2022-08-17', '2022-08-18', '2022-08-19', '2022-08-20', '2022-08-21', '2022-08-22', '2022-08-23', '2022-08-24', '2022-08-25', '2022-08-26', '2022-08-27', '2022-08-28', '2022-08-29', '2022-08-30']
            }
        ],
        yAxis: [
            {
                type: 'value',
                nameTextStyle: {
                    fontSize: '16'
                }
            }
        ],
        series: chartData[id].data
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
const spectrumPieEcharts = (id) => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        title: {
            text: '总计',
            // 副标题
            subtext: "8300kWh",
            // 主副标题间距
            itemGap: 30,
            x: 'center',
            y: 'center',
            top: '200',
            // 主标题样式
            textStyle: {
                fontSize: 20,
            },
            // 副标题样式
            subtextStyle: {
                fontSize: 18,
                fontWeight: '800',
                color: 'black'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}万KWh ({d}%)'

        },

        series: [

            {
                name: i18n.global.t('Monthly flat, valley and peak power consumption ratio'),
                type: 'pie',
                radius: [100, 140],
                itemStyle: {
                    borderRadius: 0
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 30,
                        fontWeight: 'bold'
                    }
                },
                data: [
                    { value: 10.693, name: i18n.global.t('Valley hour electricity rates') },
                    { value: 8.41, name: i18n.global.t('Usual electricity bill') },
                    { value: 9.53, name: i18n.global.t('Peak hour power consumption') },
                ]
            }
        ]
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
const spectrumBarEcharts = (id) => {

    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        title: {
            text: i18n.global.t("Monthly inhalation electricity bill"),
            textStyle: {
                fontSize: 18
            },
            top: 10,
            left: 10
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                // Use axis to trigger tooltip
                type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            },

        },
        legend: {
            data: [i18n.global.t('Usual electricity bill'),
            i18n.global.t('Peak hour electricity rates'),
            i18n.global.t('Valley hour electricity rates'),
            i18n.global.t('Total Aspiration Cost'),
            i18n.global.t('Aspiration cost')],
            top: 20,
            textStyle: {
                //图例字体大小
                fontSize: 24,
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: ['2022-08-09', '2022-08-10', '2022-08-11', '2022-08-12', '2022-08-13', '2022-08-14', '2022-08-15', '2022-08-16', '2022-08-17', '2022-08-18', '2022-08-19', '2022-08-20', '2022-08-21', '2022-08-22', '2022-08-23', '2022-08-24', '2022-08-25', '2022-08-26', '2022-08-27', '2022-08-28', '2022-08-29', '2022-08-30']
        },
        yAxis: [
            {
            },
            {
                type: 'value',
                min: 0,
                max: 50,
                interval: 10,
            },



        ],
        series: [
            {
                name: i18n.global.t('Usual electricity bill'),
                type: 'bar',
                stack: 'total',

                emphasis: {
                    focus: 'series'
                },
                data: [350, 360000, 340000, 370000, 310000, 300000, 320000, 330000, 310000, 320000, 340000, 350000, 310000, 320000, 330000, 350000, 370000, 310000, 320000, 340000, 310000, 360000]
            },
            {
                name: i18n.global.t('Peak hour electricity rates'),
                type: 'bar',
                stack: 'total',

                emphasis: {
                    focus: 'series'
                },
                data: [250000, 260000, 240000, 270000, 210000, 200000, 220000, 20000, 210000, 220000, 240000, 250000, 210000, 220000, 20000, 250000, 270000, 210000, 220000, 240000, 210000, 260000]
            },
            {
                name: i18n.global.t('Valley hour electricity rates'),
                type: 'bar',
                stack: 'total',

                emphasis: {
                    focus: 'series'
                },
                data: [150000, 160000, 140000, 170000, 110000, 100000, 120000, 10000, 110000, 120000, 140000, 150000, 110000, 120000, 10000, 150000, 170000, 110000, 120000, 140000, 110000, 160000]
            },
            {
                name: i18n.global.t('Total Aspiration Cost'),

                type: 'line',
                yAxisIndex: 1,
                emphasis: {
                    focus: 'series'
                },

                data: [35, 36, 34, 37, 31, 30, 32, 33, 31, 32, 34, 35, 31, 32, 33, 35, 37, 31, 32, 34, 31, 36]
            },
            {
                name: i18n.global.t('Aspiration cost'),
                type: 'line',
                yAxisIndex: 1,
                emphasis: {
                    focus: 'series'
                },
                data: [25, 26, 24, 27, 21, 20, 22, 2, 21, 22, 24, 25, 21, 22, 2, 25, 27, 21, 22, 24, 21, 26]
            }
        ]
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
const chart6 = (id, legendData, data) => {


    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        color: ['#6691E7', '#13C56B', '#CF6FC6', '#3949AB'],
        backgroundColor: '#ffffff',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '8%',
            containLabel: true
        },
        legend: {
            data: legendData,
            icon: 'circle',
            bottom: 0,
            textStyle: {
                //图例字体大小
                fontSize: 20,
            },
        },
        title: {
            text: '',
            textStyle: {
                fontSize: 18
            },
            top: 10,
            left: 10
        },
        // grid: {
        //     left: 100,
        //     right: 100
        // },
        toolbox: {
            show: false,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar', 'stack'] },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisTick: { show: false },
                data: data,
                axisLabel: {
                    fontSize: 18
                }
            }
        ],
        yAxis: [
            {
                name: 'kWh',
                type: 'value',
                max: 180, axisLabel: {
                    fontSize: 18
                },
                nameTextStyle: {
                    fontSize: 18

                },

            }
        ],
        series: [
            {
                name: legendData[0],
                barGap: 0,
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: [1.8, 0.6, 0.61, 0.81, 1, 2, 2.5, 1, 1.4, 0.2, 0.5, 1.8].map(() => {
                    return rand(100, 117)
                }),
                markLine: {
                    data: [{
                        type: 'average',
                        name: legendData[2],
                        yAxis: 168,
                        label: {
                            fontSize: 20
                        },
                        lineStyle: { color: "#3949AB" }
                    }]
                }

            },

            {
                name: legendData[1],
                type: 'bar',
                barGap: 0,
                emphasis: {
                    focus: 'series'
                },
                data: [0.5, 0.3, 0.2, 0.4, 0.6, 0.2, 1, 1.4, 0.8, 0.9, 0.2, 0.2].map(() => {
                    return rand(33, 37)
                }),
                markLine: {
                    data: [{
                        type: 'average',
                        name: legendData[3],
                        yAxis: 48,

                        label: {
                            fontSize: 20
                        },
                        lineStyle: { color: "#CF6FC6" }
                    }]
                }
            },
            {
                name: legendData[2],
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: '#CF6FC6'
                },
                symbol: "none",
                data: [],

            },
            {
                name: legendData[3],
                type: 'line',
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: '#3949AB'
                },
                symbol: "none",
                data: [],

            }

        ]
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}


const chart7 = (id, legendData, data) => {

    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        backgroundColor: '#ffffff',
        legend: {
            data: legendData,
            bottom: 2,
            textStyle: {
                //图例字体大小
                fontSize: 20,
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            top: '10%',
            bottom: '13C56B%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
                show: false
            },
            axisLabel: {
                margin: 15,
                fontSize: 18

            },
            data: data
        },
        yAxis: {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
                fontSize: 18

            },
            axisLabel: {
                fontSize: 18
            },
            max: 220,
            splitNumber: 9, // 设置y轴刻度间隔个数
            splitLine: {
                show: true,

            },

        },
        series: [
            {
                name: legendData[0],
                data: [198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198, 198],
                type: 'line',
                color: '#B8E795',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#C6E7AD',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#B8E795',
                },
            },
            {
                name: legendData[1],

                data: [3, 4, 5, 6, 7, 8, 9, 9.5, 9.8, 9, 5.3, 2.3, 2.2, 1, 2, 3].map(() => {
                    return rand(120, 140)
                }),
                type: 'line',
                color: '#90A3DF',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#90A3DF',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#7F96E3'
                }

            },
        ]
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
const chart8 = (id) => {

    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        color: ['#6691E7', '#CF6FC6'],
        backgroundColor: '#ffffff',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '8%',
            containLabel: true
        },
        legend: {
            data: chartData[id].legendData,
            icon: 'circle',
            bottom: 0,
            textStyle: {
                //图例字体大小
                fontSize: 18,
            },
        },
        title: {
            text: '',
            textStyle: {
                fontSize: 18
            },
            top: 10,
            left: 10
        },
        // grid: {
        //     left: 100,
        //     right: 100
        // },
        toolbox: {
            show: false,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar', 'stack'] },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisTick: { show: false },
                data: ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00']
            }
        ],
        yAxis: [
            {
                name: 'kw',
                type: 'value'
            }
        ],
        series: chartData[id].data
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
const chart9 = (id, legendData,data,data1,data2) => {

    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, { renderer: 'svg' });
    var option;

    option = {
        backgroundColor: '#ffffff',
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data:legendData,
            bottom: 5,
            textStyle: {
                fontSize: 20,
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            top: '9%',
            bottom: '13C56B%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
                show: false
            },
            axisLabel: {
                margin: 15,
                fontSize: 18,
            },

            data: data
        },
        yAxis: {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
                fontSize: 18

            },
            axisLabel: {
                fontSize: 18
            },
            // splitNumber: 9, // 设置y轴刻度间隔个数
            splitLine: {
                show: true,

            },

        },
        series: [
            {
                name: legendData[0],
                data: data1,
                type: 'line',
                color: '#B8E795',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#C6E7AD',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#B8E795',
                },
            },
            {
                name: legendData[1],

                data: data2,
                type: 'line',
                color: '#90A3DF',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#90A3DF',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#7F96E3'
                }

            },
        ]
    };
    option && myChart.setOption(option,true);
    window.addEventListener("resize", () => { myChart.resize(); });

}
export {
    spectrumEcharts,
    spectrumPieEcharts,
    spectrumBarEcharts,
    chart6,
    chart7,
    chart9,
    chart8
}